import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Modal from "@mui/material/Modal";
import { DateUtil } from "../../fxms/datas/DateUtil";

const buildSeriesData = (list = []) => {
  return list
    .filter((row) => row && row.psDate)
    .map((row) => [
      DateUtil.makeDate(String(row.psDate)).getTime(),
      parseFloat(row.consAmt ?? row.consInstVal ?? 0),
    ])
    .sort((a, b) => a[0] - b[0]);
};

const chartOptions = (title, dataToday, dataBefor, isDetail) => {
  const allPoints = [...dataToday, ...dataBefor];
  const baseDate =
    allPoints.length > 0 ? new Date(allPoints[0][0]) : new Date();
  const startOfDay = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    0,
    0,
    0,
    0
  ).getTime();
  const endOfDay = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    23,
    59,
    59,
    999
  ).getTime();

  return {
  title: { text: title, align: "center" },
  chart: {
    height: isDetail ? 320 : 200,
    backgroundColor: "#313131",
    borderWidth: 1,
    borderColor: "#303030",
    plotBackgroundColor: "#303030",
    plotBorderWidth: 1,
    plotBorderColor: "#303030",
  },
  xAxis: {
    type: "datetime",
    min: startOfDay,
    max: endOfDay,
    tickInterval: 3 * 60 * 60 * 1000,
    labels: {
      style: { color: "rgba(255,255,255,0.8)" },
      formatter: function () {
        const d = new Date(this.value);
        if (d.getMinutes() === 0) {
          return `${d.getHours()}시`;
        }
        return "";
      },
    },
  },
  yAxis: {
    title: { text: null },
    lineWidth: 1,
    lineColor: "#3e3e3e",
    gridLineColor: "#3e3e3e",
  },
  tooltip: {
    shared: true,
    formatter: function () {
      const time = new Date(this.x).toLocaleTimeString("ko-KR", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
      return ["<b>" + time + "</b><br>"]
        .concat(
          this.points
            ? this.points.map((p) =>
                `<b>${p.series.name}</b>: ${Math.round(p.y).toLocaleString(
                  "ko-KR"
                )} kWh`
              )
            : []
        )
        .join("<br>");
    },
  },
  plotOptions: {
    series: {
      animation: false,
      marker: { lineWidth: 1 },
    },
  },
  legend: { enabled: isDetail },
  series: [
    {
      name: "당일",
      type: "line",
      data: dataToday,
      tooltip: { valueSuffix: "kWh" },
      color: "#85D775",
      marker: { enabled: true, radius: 2 },
    },
    {
      name: "전일",
      type: "line",
      data: dataBefor,
      tooltip: { valueSuffix: "kWh" },
      visible: isDetail,
      color: "#77a6ff",
      marker: { enabled: true, radius: 2 },
    },
  ],
  };
};

export const FxKepcoPowerChart = forwardRef(({ dataToday = [], dataBefor = [] }, ref) => {
  const [open, setOpen] = useState(false);

  const todaySeries = useMemo(() => buildSeriesData(dataToday), [dataToday]);
  const beforSeries = useMemo(() => buildSeriesData(dataBefor), [dataBefor]);
  useImperativeHandle(ref, () => ({
    openDetail: () => setOpen(true),
    closeDetail: () => setOpen(false),
  }));

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions("", todaySeries, [], false)}
        />
      </div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        className="detail-chart-modal"
      >
        <div className="detail-chart-container">
          <div className="predict" style={{ height: "100%" }}>
            <div className="vupNewLayerPop">
              <div className="lpopTitle">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 20px",
                  }}
                >
                  <h3>실시간 전력 사용 상세 (한전 15분)</h3>
                  <div className="closeBtn" onClick={() => setOpen(false)}>
                    <img src="../svgCloseBtn_on.svg" />
                    <img src="../svgCloseBtn.svg" />
                  </div>
                </div>
              </div>
              <div
                className="lpopContent detail-chart"
                style={{ height: "calc(100% - 40px)" }}
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={chartOptions(
                    "실시간 전력 사용현황",
                    todaySeries,
                    beforSeries,
                    true
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
});

FxKepcoPowerChart.displayName = "FxKepcoPowerChart";
